import { gql } from "@apollo/client"
import styled from "@emotion/styled"
import { mq, Text, theme } from "@pallet-hq/hegel"
import { SpaceBetweenRow } from "components/atoms"
import moment from "moment"
import { PosterDetails_post } from "__generated__/PosterDetails_post"

const PosterDetailsFragment = gql`
    fragment PosterDetails_post on PostType {
        firstPublishedAt
        createdBy {
            id
            recruiter {
                id
                email
                fullName
            }
        }
    }
`

export type PosterDetailsProps = {
    post: PosterDetails_post
}

const PosterDetails = ({ post }: PosterDetailsProps) => {
    const hasName =
        post.createdBy?.recruiter.fullName &&
        post.createdBy.recruiter.fullName !== post.createdBy.recruiter.email

    return (
        <Wrapper>
            <Text
                variant="uiSmall600"
                textTransform="uppercase"
                color="gray600"
            >
                Job Poster Details
            </Text>
            <Row>
                {hasName && <div>{post.createdBy?.recruiter.fullName}</div>}
                <Underline href={`mailto:${post.createdBy?.recruiter.email}`}>
                    {post.createdBy?.recruiter.email}
                </Underline>
                <div>{moment(post.firstPublishedAt).format("l")}</div>
            </Row>
        </Wrapper>
    )
}

PosterDetails.fragment = PosterDetailsFragment
export default PosterDetails

const Wrapper = styled.div`
    background: ${theme.colors.gray100};
    border: 1px solid ${theme.colors.gray400};
    border-radius: 8px;
    padding: ${theme.space.small};
    margin: ${theme.space.small} 0;
`

const Row = styled(SpaceBetweenRow)`
    margin-top: ${theme.space.xsmall};
    ${mq({ flexDirection: ["column", "column", "row"] })};
`

const Underline = styled.a`
    color: inherit;
`
